import { css } from 'styled-components';
export var media = {
  smallScreen: function smallScreen() {
    return css(["@media screen and (max-width:420px){", ";}"], css.apply(void 0, arguments));
  },
  mediumScreen: function mediumScreen() {
    return css(["@media screen and (max-width:768px){", ";}"], css.apply(void 0, arguments));
  },
  largeScreen: function largeScreen() {
    return css(["@media screen and (max-width:1024px){", ";}"], css.apply(void 0, arguments));
  },
  extraLargeScreen: function extraLargeScreen() {
    return css(["@media screen and (min-width:1025px){", ";}"], css.apply(void 0, arguments));
  }
};
export var matchesMediaQuery = function matchesMediaQuery(query) {
  return typeof window !== 'undefined' && window.matchMedia && window.matchMedia(query).matches;
};
export var placeholder = function placeholder() {
  return css(["::-webkit-input-placeholder{", "}::-moz-placeholder{", "}:-ms-input-placeholder{", "}:-moz-placeholder{", "}"], css.apply(void 0, arguments), css.apply(void 0, arguments), css.apply(void 0, arguments), css.apply(void 0, arguments));
};